import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardMetricListPage from '../components/dashboard/DashboardMetricListPage';

function useMetricPeriodParams() {
  const [searchParams] = useSearchParams();
  const year = searchParams.get('year');
  const month = searchParams.get('month');
  const hasYearMonth = year && month;
  const period = hasYearMonth || searchParams.get('period') === 'month' ? 'month' : 'today';
  return { year, month, hasYearMonth, period };
}

const DashboardMetricOrders = () => {
  const { t } = useTranslation();
  const { year, month, hasYearMonth, period } = useMetricPeriodParams();

  const apiPath = useMemo(() => {
    if (hasYearMonth) {
      return `/api/dashboard/metrics/orders?year=${year}&month=${month}`;
    }
    return `/api/dashboard/metrics/orders?period=${period}`;
  }, [hasYearMonth, year, month, period]);

  const title = period === 'month'
    ? t('dashboard.activity.ordersMonthTitle')
    : t('dashboard.activity.ordersTodayTitle');

  const subtitle = period === 'month'
    ? (hasYearMonth
      ? t('dashboard.activity.ordersMonthSelectedSubtitle', { year, month })
      : t('dashboard.activity.ordersMonthSubtitle'))
    : t('dashboard.activity.ordersTodaySubtitle');

  return (
    <DashboardMetricListPage
      apiPath={apiPath}
      title={title}
      subtitle={subtitle}
      countLabel={t('dashboard.activity.totalOrderValue')}
      emptyMessage={t('dashboard.activity.noOrders')}
      loadFailedMessage={t('dashboard.activity.loadOrdersFailed')}
      requiredPermissions={['view_dashboard_today', 'view_dashboard_monthly_orders']}
    />
  );
};

export default DashboardMetricOrders;
